"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _getAssetsCoin = require("../../common/getAssetsCoin");

var _SocketDispatcher = _interopRequireDefault(require("@/assets/js/SocketDispatcher"));

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_commonMixin.default],
  props: ["data", "assetsList", "is_recharge"],
  data: function data() {
    return {
      coinData: {},
      oldCoinData: [],
      coinList: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language",
    systemCurrency: "user/currency"
  })),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var item;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _getAssetsCoin.getCoinInfo)();

            case 2:
              _this.coinData = _context.sent;

              for (item in _this.coinData) {
                _this.coinData[item].capital_name = _this.coinData[item].itemDetail.capital_name;
                _this.coinData[item].language = _this.coinData[item].itemDetail.language["display_" + _this.language];

                _this.coinList.push(_this.coinData[item]);
              }

              _this.oldCoinData = _this.coinList;
              Object.keys(_this.coinData).forEach(function (item_id) {
                var itemDetail = _this.coinData[item_id]["itemDetail"];

                if (itemDetail["in_status"] === 0 || itemDetail["out_status"] === 0) {
                  delete _this.coinData[item_id];
                }
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    onFilterItem: function onFilterItem(val) {
      var _this2 = this;

      if (val) {
        this.coinList = [];
        this.coinList = this.oldCoinData.filter(function (ele) {
          var capital_name = String(ele.capital_name.toUpperCase());
          var language = String(ele.language);

          if (capital_name.indexOf(val.toUpperCase()) != -1) {
            _this2.coinList.push(ele);
          }
        });
      } else {
        this.coinList = this.oldCoinData;
      }
    },
    // 选择币种
    selectChange: function selectChange(val) {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var key, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(val == _this3.data.item_id)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return (0, _getAssetsCoin.getAssetsData)();

              case 4:
                for (key in _this3.coinData) {
                  if (val == key) {
                    query = JSON.parse(JSON.stringify(_this3.coinData[key].itemDetail.logic_name));

                    _this3.$router.replace(query);

                    _SocketDispatcher.default.dispatchEvent("onChainChangeDispatch", _this3.coinData[key].itemDetail.default_chain);

                    _this3.$emit("changeAssetData", _this3.coinData[key]);
                  }
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};
exports.default = _default;